const paymentMethodsNL = {
    "view": {
        "table": {
            "title": "Uw betalingsmethodenlijst",
            "column": {
                "cardholder_name": "Naam kaarthouder",
                "card_number": "Kaartnummer",
                "expiry_month": "Vervalmaand",
                "expiry_year": "Vervaljaar",
                "type": "Type",
                "status": "Status",
                "action": "Actie"
            },
            "label": {
                "is_default": "Standaard",
                "is_secondary": "Secundair",
                "is_valid": "Geldig",
                "is_expired": "Verlopen",
                "not_available": "Niet beschikbaar",
                "month_january": "Januari",
                "month_february": "Februari",
                "month_march": "Maart",
                "month_april": "April",
                "month_may": "Mei",
                "month_june": "Juni",
                "month_july": "Juli",
                "month_august": "Augustus",
                "month_september": "September",
                "month_october": "Oktober",
                "month_november": "November",
                "month_december": "December"
            },
            "dropdown": {
                "action": "Actie",
                "edit": "Bewerken",
                "delete": "Verwijderen"
            }
        },
        "message": {
            "maxPaymentMethodsLimitReached": "U heeft de limiet van 3 betalingsmethoden bereikt. Als u een nieuwe betaling wilt toevoegen, kunt u dat doen door een bestaande te verwijderen.",
            "success": "Betalingsmethode is verwijderd!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
        },
        "modal": {
            "delete": {
                "header": "Betalingsmethode verwijderen {{cardNumber}}",
                "body": "Weet u zeker dat u deze betalingsmethode wilt verwijderen?"
            }
        }
    },
    "add": {
        "title": "Betalingsmethode toevoegen",
        "form": {
            "label": {
                "card_details": "Kaartgegevens",
                "cardholder_name": "Naam kaarthouder",
                "card_number": "Kaartnummer",
                "expiry_month": "Vervalmaand",
                "expiry_year": "Vervaljaar (JJJJ)",
                "security_code_cvc": "Beveiligingscode (CVC)",
                "billing_details": "Factuurgegevens",
                "country": "Land",
                "street_and_number": "Straat en huisnummer",
                "city": "Stad",
                "postal_code": "Postcode"
            },
            "help_text": {
                "security_code_cvc": "De beveiligingscode (CVC) van uw kaart is het 3- of 4-cijferige nummer op de achterkant van de meeste kaarten."
            },
            "options": {
                "month": {
                    "january": "Januari",
                    "february": "Februari",
                    "march": "Maart",
                    "april": "April",
                    "may": "Mei",
                    "june": "Juni",
                    "july": "Juli",
                    "august": "Augustus",
                    "september": "September",
                    "october": "Oktober",
                    "november": "November",
                    "december": "December"
                },
                "expiry_month": {
                    "select": "Selecteer vervalmaand"
                },
                "country": {
                    "select": "Selecteer land"
                }
            },
            "button": {
                "submit": "Verzenden"
            },
            "validation": {
                "expiry_month_required": "Vervalmaand is vereist",
                "expiry_month_valid": "Vervalmaand mag niet in het verleden liggen",
                "country_required": "Land is vereist"
            }
        },
        "message": {
            "success": "Betalingsmethode is toegevoegd!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
        },
        "modal": {
            "addPaymentMethod": {
                "header": "Weet u zeker dat u deze betalingsmethode aan uw profiel wilt toevoegen?",
                "body": "Hierbij garandeert u dat alle verstrekte gegevens waarheidsgetrouw zijn. U bent als enige en wettelijk verantwoordelijk voor de verstrekte gegevens en voor de waarheidsgetrouwheid van dergelijke informatie.",
                "button": {
                    "cancel": "Annuleren",
                    "confirm": "Bevestigen"
                }
            }
        }
    },
    "update": {
        "title": "Betalingsmethode bijwerken",
        "form": {
            "label": {
                "card_details": "Kaartgegevens",
                "cardholder_name": "Naam kaarthouder",
                "card_number": "Kaartnummer",
                "expiry_month": "Vervalmaand",
                "expiry_year": "Vervaljaar (JJJJ)",
                "security_code_cvc": "Beveiligingscode (CVC)",
                "billing_details": "Factuurgegevens",
                "country": "Land",
                "street_and_number": "Straat en huisnummer",
                "city": "Stad",
                "postal_code": "Postcode",
                "set_as_default": "Instellen als standaard"
            },
            "help_text": {
                "security_code_cvc": "De beveiligingscode (CVC) van uw kaart is het 3- of 4-cijferige nummer op de achterkant van de meeste kaarten."
            },
            "options": {
                "month": {
                    "january": "Januari",
                    "february": "Februari",
                    "march": "Maart",
                    "april": "April",
                    "may": "Mei",
                    "june": "Juni",
                    "july": "Juli",
                    "august": "Augustus",
                    "september": "September",
                    "october": "Oktober",
                    "november": "November",
                    "december": "December"
                },
                "expiry_month": {
                    "select": "Selecteer vervalmaand"
                },
                "country": {
                    "select": "Selecteer land"
                }
            },
            "button": {
                "submit": "Verzenden"
            },
            "validation": {
                "expiry_month_required": "Vervalmaand is vereist",
                "expiry_month_valid": "Vervalmaand mag niet in het verleden liggen",
                "country_required": "Land is vereist"
            }
        },
        "message": {
            "success": "Betalingsmethode is bijgewerkt!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
        },
        "modal": {
            "updatePaymentMethod": {
                "header": "Weet u zeker dat u uw betalingsmethode wilt bijwerken?",
                "body": "Hierbij garandeert u dat alle verstrekte gegevens waarheidsgetrouw zijn. U bent als enige en wettelijk verantwoordelijk voor de verstrekte gegevens en voor de waarheidsgetrouwheid van dergelijke informatie.",
                "button": {
                    "cancel": "Annuleren",
                    "confirm": "Bevestigen"
                }
            }
        }
    }
};

export default paymentMethodsNL;